import {Component, Input} from '@angular/core';

/**
 * Generated class for the MoodFaceComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mood-face',
  templateUrl: 'mood-face.html'
})
export class MoodFaceComponent {

  @Input() face: string;
  @Input() selected: boolean;
  @Input() black: boolean;

  color: string;

  constructor() {
    this.color = '#9E9B9B';
  }

  ngAfterViewInit() {
    if(this.black) {
      this.color = '#212121';
    }
    if(this.selected) {
      this.color = '#006A79';
    }
  }

  ngOnChanges() {
    this.color = '#9E9B9B';
    if(this.black) {
      this.color = '#212121';
    }
    if(this.selected) {
      this.color = '#006A79';
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/mood-face/mood-face.ts